<script>
	import { getContext } from 'svelte';
	import { TABS } from './Tabs.svelte';

	export let active = false;

	const tab = {active};
	const { registerTab, selectTab, selectedTab } = getContext(TABS);

	registerTab(tab);
</script>

<style>
	
</style>

<button class="tab-btn" class:selected="{$selectedTab === tab}" on:click="{() => selectTab(tab)}">
	<slot></slot>
</button>